export const createGermanNumberFormatter = (options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat('de', options)

const germanNumberFormatter = createGermanNumberFormatter()

export const formatGermanNumber = (value: number): string => germanNumberFormatter.format(value)
